import { PortableText as PortableTextComponent } from '@portabletext/react';
import React from 'react';

import { InternalExternalLink } from '@/components/Link/InternalExternalLink';
import LazyYouTube from '@/components/Youtube';
import { ResponsiveImage } from '@/components/images/ResponsiveImage';

export const PortableText = ({ content, components }) => {
  components = components || {
    marks: {
      link: ({ value, children }) => (
        <InternalExternalLink link={value.href}>{children}</InternalExternalLink>
      ),
    },
    types: {
      image: ({ value }) => (
        <div className="w-full max-w-[1160px] not-prose">
          <ResponsiveImage
            asset={value.asset}
            hotspot={value.hotspot}
            alt=""
            layout="intrinsic"
            roundSize={100}
            preventResize
          />
        </div>
      ),
      youtube: ({ value }) => (
        <LazyYouTube
          className="not-prose"
          url={value?.url}
          background={false}
          loop={false}
          autoPlay={false}
        />
      ),
    },
  };

  return <PortableTextComponent value={content} components={components} />;
};
